module.exports = __webpack_public_path__ + "img/horizontal_7_5_pp23_8.fd6c9e09.png";